module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/top-img.12703c9d.png";